import { useContext } from 'react';
import { UpgradeDialogContext } from './upgrade-dialog-provider';

export function useUpgradeDialog() {
  return useContext(UpgradeDialogContext);
}
